import { MuvenRoleEnum } from "@c2b/muven-commons";

interface MuvenRoleEnumWrapper {
    enum: MuvenRoleEnum;
    name: string;
    description: string;
}

export class UserInvitationMemberModel {
    firstName: string = "";
    lastName: string = "";
    phone: string = "";
    email: string = "";
    roles: MuvenRoleEnumWrapper[]|MuvenRoleEnum[] = [];

    constructor(u?:Partial<UserInvitationMemberModel>) {
        Object.assign(this, u)
    }

    hasRole() {
        return !!this.roles.length;
    }

    isValid():boolean {
        return !!this.firstName && 
            (!!this.phone || !!this.email)
    }

    normalize():any {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
            roles: (this.roles as MuvenRoleEnumWrapper[] || []).map((role) => {
                return role.enum
            }),
        }
    }
}
